import React from 'react';

import { Button, Grid, Typography } from '@material-ui/core';

import CardLoginForm from './CardLoginForm';
import { useStyles } from './styles';

import { FORM_LOGIN_LABELS } from '../../../consts/text/form-login';

function MultiCardAccess({
  btnText,
  description,
  href,
  icon,
  showLoginForm,
  title,
  gtm,
}) {
  const classes = useStyles({ showLoginForm });

  const handleClick = (path) => {
    window.open(path, '_blank');
  };

  return (
    <Grid item container alignItems="center" direction="column">
      <Grid
        item
        container
        direction="column"
        justifyContent="flex-start"
        alignItems="center"
        className={classes.gridContainer}
      >
        <Typography className={classes.title}>{title}</Typography>

        <Grid
          item
          container
          justifyContent="center"
          alignItems="center"
          className={classes.gridIconContainer}
        >
          <img
            src={icon}
            className={classes.icon}
            alt="Icone de acesso ao portal"
          />
          <Typography className={classes.btnText}>{btnText}</Typography>
        </Grid>

        <Typography className={classes.description}>{description}</Typography>

        {showLoginForm ? (
          <CardLoginForm isNaoCorrentista gtm={gtm} />
        ) : (
          <Button
            color="secondary"
            variant="contained"
            className={classes.btnAcessar}
            disableElevation
            onClick={() => handleClick(href)}
            data-testid="testBtnMultiCardAccess"
            {...gtm}
          >
            <Typography className={classes.btnAcessarText} {...gtm}>
              {FORM_LOGIN_LABELS.BTN_ACESSAR}
            </Typography>
          </Button>
        )}
      </Grid>
    </Grid>
  );
}

export default MultiCardAccess;
